import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import { ChangeEvent, ReactNode } from "react";

export const FIELD_INPUT_BG = "#1a2433";
export const FIELD_OUTPUT_BG = "#0f1520";

const FIELD_BORDER = "whiteAlpha.200";

interface StakeAmountFieldProps {
  label: string;
  variant: "input" | "output";
  tokenSelector: ReactNode;
  amount: string;
  onAmountChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  amountInputType?: "text" | "number";
  headerRight?: ReactNode;
}

export const StakeAmountField = ({
  label,
  variant,
  tokenSelector,
  amount,
  onAmountChange,
  readOnly = false,
  amountInputType = "text",
  headerRight,
}: StakeAmountFieldProps) => (
  <Box
    bg={variant === "input" ? FIELD_INPUT_BG : FIELD_OUTPUT_BG}
    borderRadius="2xl"
    border="1px solid"
    borderColor={FIELD_BORDER}
    p={4}
    width="100%"
  >
    <Flex justify="space-between" align="center" mb={3} gap={2} minH="24px">
      <Text fontSize="sm" fontWeight="medium" color="whiteAlpha.800">
        {label}
      </Text>
      {headerRight}
    </Flex>

    <Flex align="center" justify="space-between" gap={3}>
      <Box flexShrink={0}>{tokenSelector}</Box>
      <Input
        flex={1}
        minW={0}
        variant="unstyled"
        type={amountInputType}
        placeholder="0"
        value={amount}
        onChange={onAmountChange}
        readOnly={readOnly}
        textAlign="right"
        fontSize="3xl"
        fontWeight="semibold"
        lineHeight="1.1"
        color="white"
        _placeholder={{ color: "whiteAlpha.500" }}
        sx={{
          _light: { color: "white" },
          _dark: { color: "white" },
        }}
      />
    </Flex>
  </Box>
);

interface BalanceMaxHeaderProps {
  displayedBalance: string;
  onMax?: () => void;
  maxDisabled?: boolean;
}

export const BalanceMaxHeader = ({
  displayedBalance,
  onMax,
  maxDisabled,
}: BalanceMaxHeaderProps) => (
  <HStack spacing={2} alignItems="center" flexShrink={0}>
    <Image src="/wallet-icon.svg" boxSize="14px" opacity={0.8} />
    <Text fontSize="xs" color="whiteAlpha.800" whiteSpace="nowrap">
      {displayedBalance}
    </Text>
    {onMax && (
      <Button
        size="xs"
        onClick={onMax}
        variant="ghost"
        color="whiteAlpha.900"
        bg="whiteAlpha.200"
        _hover={{ bg: "whiteAlpha.300" }}
        fontWeight="medium"
        borderRadius="md"
        px={2}
        h="22px"
        minH="22px"
        isDisabled={maxDisabled}
      >
        MAX
      </Button>
    )}
  </HStack>
);

export const ReceiveHintHeader = ({ hint }: { hint: string }) =>
  hint ? (
    <Text fontSize="xs" color="whiteAlpha.700" textAlign="right" whiteSpace="nowrap">
      {hint}
    </Text>
  ) : null;
